export default function booleanify(value: string): any {
	const evalBool: any = { true: true, false: false };
	const evaluatedBoolean = evalBool[value];
	return typeof evaluatedBoolean === 'boolean' ? evaluatedBoolean : value;
}
